import { ErroredModel } from './ErroredModel';
import { Task } from './Task';

export type Step = ErroredModel & {
  uuid: string;
  name: string;
  order: number;
  task_uuid?: string;
  completed_at?: string;
  completed_by_name?: string;
  started_at?: string;
  started_by_name?: string;
  task?: Task;
};

export enum StepAction {
  START = 'start',
  COMPLETE = 'complete',
}
